<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="ChevronLeftIcon" @click="close()" />
    </template>
    <template #title>{{ content.title }}</template>

    <Sheet.Body>
      <AccountClosureInfoBody :mode="mode" />
    </Sheet.Body>

    <div
      class="flex shrink-0 flex-col gap-2.5 px-4 pt-2 pb-[calc(env(safe-area-inset-bottom)+16px)]"
    >
      <Button
        variant="danger"
        size="lg"
        @click="handlePrimary"
      >
        {{ primaryLabel }}
      </Button>
      <Button variant="stroke" size="lg" @click="handleKeep">
        {{ content.secondary }}
      </Button>
    </div>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Sheet, Button, useSheet } from '@dacr/library'
import { ChevronLeftIcon } from '@dacr/icons'

import { openModal, Modals, closeAllModals } from '@/shared/dialogs/modals'
import { closeAllSheets } from '@/shared/dialogs/sheets'
import AccountClosureInfoBody from './AccountClosureInfoBody.vue'
import { closureContent, type ClosureMode } from '../content'
import { useOutstandingBalance } from '../useOutstandingBalance'

const props = defineProps<{ mode: ClosureMode }>()

const { close } = useSheet()
const { hasOutstandingBalance } = useOutstandingBalance()

const content = computed(() => closureContent[props.mode].info)
const primaryLabel = computed(() =>
  hasOutstandingBalance.value
    ? content.value.primaryWithBalance
    : content.value.primaryNoBalance
)

const handlePrimary = () => {
  closeAllSheets()
  openModal(Modals.ConfirmAccountClosure, { props: { mode: props.mode } })
}

const handleKeep = () => {
  closeAllModals()
  closeAllSheets()
}
</script>
